import React, { useContext, useEffect } from "react";
import Panel from "./Panel";

import { useSelector, useDispatch } from "react-redux";
import { map_coins, map_coin_to_name } from "store/constant";
import { map_balance_to_coin } from "store/constant";
// import useKrakenOHLC from "hooks/useKrakenOHLC";
import { IconButton } from "@material-ui/core";
import { setKrakenInterval, KRAKEN_OHLC_INTERVAL, SET_MULTI_MAP_INDEX, SET_MULTI_MAP_VALUE } from "store/actions";
import DailyHiLo from "../../components/DailyHiLo";
import colors from "assets/scss/_themes-vars.module.scss";
import ToolTipHelper from 'ui-component/ToolTipHelper';
import {tooltips} from 'constants/tooltips';
import SearchIcon from "@material-ui/icons/Search";
import useAlpacaOHLC from "hooks/useAlpacaOHLC";

// material-ui
import { useTheme } from "@material-ui/styles";
import { Chip, Grid, Box, Typography, Tab, Tabs } from "@material-ui/core";
import {
  setModalSearchStatus,
} from "store/actions";

// third party
import TakyonLightweightChart from "./Chart";

// project imports
import SubCard from "ui-component/cards/SubCard";

import TrendingDownIcon from "@material-ui/icons/TrendingDown";
import TradesCoin from "../../Trades/TradesCoin";
import OrdersCoin from "./OrdersCoin.js";

// ===========================|| DASHBOARD ANALYTICS - MARKET SHARE AREA CHART CARD ||=========================== //

const MultiChartCard = ({index_label}, {coin}) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const cornsilk =
    theme.palette.mode === "dark"
      ? colors.cornsilkLightTakyon
      : colors.cornsilkDarkTakyon;
  const whiteTakyon =
    theme.palette.mode === "dark"
      ? colors.whiteLightTakyon
      : colors.whiteDarkTakyon;
  const green =
    theme.palette.mode === "dark"
      ? colors.successLightTakyon
      : colors.successDarkTakyon;
  const red =
    theme.palette.mode === "dark"
      ? colors.errorLightTakyon
      : colors.errorDarkTakyon;

  // TMD console.log( 'MULTI_CHART_CARD.... ' + index_label.coin);
  // TMD console.log(index_label);

  const multiMap = useSelector((state) => { return state.favorites.multiMap;});

  const m_coin = multiMap.get(index_label.index);
  // TMD console.log( 'M_COIN----------------- ' + m_coin);

    const { fetchAlpacaOHLC } = useAlpacaOHLC();

  const ohlcInterval = useSelector((state) => state.chart.ohlcInterval);
  const setInterval = (interval) => dispatch(setKrakenInterval(interval));

    useEffect(() => {
        console.log( 'SAMEER ----- FETCH_ALPACA_OHLC -------------------------- ' + m_coin + ', ' + ohlcInterval);
        fetchAlpacaOHLC(m_coin, ohlcInterval); // default interval
    }, [m_coin, ohlcInterval]);

    useEffect(() => {
        console.log( 'SAMEER ----- MULTI_CHART_CARD  -------------------------- ' + m_coin + ', ' + ohlcInterval);
    }, [ohlcInterval]);

  // const customization = useSelector((state) => state.customization);
  // const { navType } = customization;

  const coin_style = map_coins.get(m_coin);
  // const coin_name = map_coin_to_name.get(m_coin) ? map_coin_to_name.get(m_coin) : m_coin;
  const coin_name = useSelector((state) => {
    const row = state.coins.kraken_asset_pairs && state.coins.kraken_asset_pairs.get(m_coin) && state.coins.kraken_asset_pairs.get(m_coin) || undefined;
    if ( row === undefined)
    {
        return m_coin;
    }
    const coin_name = row.marketcap ?  row.marketcap.Name : (row.base_currency ? row.base_currency : (row.base ? row.base : row.wsname));
    return coin_name;
  });

  const [tabsValue, setTabsValue] = React.useState(0);
  const handleChangeTab = (event, newValue) => {
    setTabsValue(newValue);
  };
  const handleModalSearch = () => {
    dispatch({ type: SET_MULTI_MAP_INDEX, payload: {"index": index_label.index}});
    dispatch(setModalSearchStatus(true));
  };



  const intervals = [
    { interval: "1", title: "1m" },
    { interval: "5", title: "5m" },
    { interval: "15", title: "15m" },
    { interval: "60", title: "1h" },
    { interval: "360", title: "6h" },
    { interval: "1440", title: "1d" },
  ];

  // colorMap = colorMap.set(ohlcInterval, 'blue');

  const ltp = useSelector((state) => {
     return (
                (state.coins.kraken_asset_pairs_loaded                  &&
                 state.coins.kraken_asset_pairs.get(m_coin)               &&
                 state.coins.kraken_asset_pairs.get(m_coin).ltp
                 )
                 || undefined);
  });

  const day_close = useSelector((state) => {
     return (
                (state.coins.kraken_asset_pairs_loaded                  &&
                 state.coins.kraken_asset_pairs.get(m_coin)               &&
                 state.coins.kraken_asset_pairs.get(m_coin).day_close
                 )
                 || undefined);
  });

  const daily = useSelector((state) => {
     return (
                (state.coins.kraken_asset_pairs_loaded                  &&
                 state.coins.kraken_asset_pairs.get(m_coin)               &&
                 state.coins.kraken_asset_pairs.get(m_coin).daily
                 )
                 || undefined);
  });

  const daily_hi = useSelector((state) => {
     return (
                (state.coins.kraken_asset_pairs_loaded                  &&
                 state.coins.kraken_asset_pairs.get(m_coin)               &&
                 state.coins.kraken_asset_pairs.get(m_coin).daily_hi
                 )
                 || 0.0);
  });
  const daily_lo = useSelector((state) => {
     return (
                (state.coins.kraken_asset_pairs_loaded                  &&
                 state.coins.kraken_asset_pairs.get(m_coin)               &&
                 state.coins.kraken_asset_pairs.get(m_coin).daily_lo
                 )
                 || 0.0);
  });
  const daily_percent = useSelector((state) => {
     return (
                (
                 state.coins.kraken_asset_pairs.get(m_coin)               &&
                 state.coins.kraken_asset_pairs.get(m_coin).hilo_percent
                 )
                 || 0.0);
  });

  return (
<>
    <Grid container padding={0.0} />
      {tabsValue === 0 &&
      <>
        <SubCard >
          <Grid container spacing={0} padding={0} alignItems="top">


            <Grid item xs={3.0}  >
              {(ltp === undefined) && (<Panel ltp={day_close} daily_hi={daily_hi} daily_lo={daily_lo} daily_percent={daily_percent} />)}
              {(ltp !== undefined) && (<Panel ltp={ltp} daily_hi={daily_hi} daily_lo={daily_lo} daily_percent={daily_percent} />)}


            </Grid>
            <Grid item xs={1.5}>
				  <Chip
					label={
					  <font
						style={{
						  horizontalAlign: "middle",
						  verticalAlign: "middle",
						  fontSize: "0.9em",
						}}
					  >
						<a class={coin_style}>{coin_name}</a>
					  </font>
					}
					onClick={handleModalSearch}
					onDelete={handleModalSearch}
					// color="success"
					// variant="outlined"
					deleteIcon={<SearchIcon />}
				  />
            </Grid>
            <Grid item xs={4.5}  align="center" justifyContent="center" alignItems="center" >
                {intervals.map((intervalItem) => (
                  <IconButton
                    key={intervalItem.interval}
                    sx={{
                      color:
                        intervalItem.interval === ohlcInterval
                          ? cornsilk
                          : colors.grey600,
                    }}
                    size="small"
                    onClick={() => setInterval(intervalItem.interval)}
                  >
                    {intervalItem.title}
                  </IconButton>
                ))}
            </Grid>
            <Grid item xs={2.0}  >
                <DailyHiLo dh={daily_hi} dl={daily_lo} ltp={ltp} avg_px={0} />
            </Grid>

          </Grid>
          <TakyonLightweightChart coin_label={m_coin}/>
        </SubCard>
      </>
      }
      {tabsValue === 1 &&
        <TradesCoin />
      }
      {tabsValue === 2 &&
        <OrdersCoin />
      }

</>
  );
};
export default MultiChartCard;
